<template>
  <el-dialog
    v-if="dialogVisible"
    :title="title"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    :append-to-body="true"
  >
    <div v-if="showPhone">
      <div class="navList">
        <div
          :class="activeIndex == 'pwd' ? 'isActive' : 'moren'"
          @click="handleSelect('pwd')"
        >
          密码
        </div>
        <div
          :class="activeIndex == 'mobile' ? 'isActive' : 'moren'"
          @click="handleSelect('mobile')"
        >
          手机号码
        </div>
      </div>
      <el-form :model="form" ref="form" label-width="100px" :rules="rules">
        <el-form-item label="手机号码" prop="mobile">
          <el-input
            v-model.number="form.mobile"
            autocomplete="off"
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pwd" v-if="activeIndex == 'pwd'">
          <el-input
            v-model="form.pwd"
            autocomplete="off"
            placeholder="请输入密码"
            show-password
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="captcha" v-if="activeIndex == 'mobile'">
          <el-input v-model="form.captcha" placeholder="请输入验证码">
            <template #suffix>
              <div v-if="messageCodeVis" class="second-text">
                {{ countdown }}秒后重新获取
              </div>
              <el-button v-else type="text" link @click="sendCode">获取验证码</el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="handlerBtn">
        <el-button type="text" @click="handlerUser(1)">忘记密码</el-button>
        <el-button type="text" @click="handlerUser(2)">用户注册</el-button>
      </div>
    </div>

    <div v-if="!showPhone">
      <div class="navList">
        <div class="isActive" v-if="forgetPsd">忘记密码</div>
        <div class="isActive" v-if="register">注册</div>
      </div>
      <el-form :model="form" ref="form" label-width="100px" :rules="rules">
        <el-form-item label="手机号码" prop="mobile">
          <el-input
            v-model.number="form.mobile"
            autocomplete="off"
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="captcha">
          <el-input v-model="form.captcha" placeholder="请输入验证码">
            <template #suffix>
              <div v-if="messageCodeVis" class="second-text">
                {{ countdown }}秒后重新获取
              </div>
              <el-button v-else type="text" link @click="sendCode">获取验证码</el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="密码" prop="pwd">
          <el-input
            v-model="form.pwd"
            autocomplete="off"
            placeholder="请输入密码"
            type="password"
          ></el-input>
          <div>提示：密码为不少于6位的数字字母组合</div>
        </el-form-item>
        <el-form-item label="确认密码" prop="pwdCheck" v-if="register">
          <el-input
            v-model="form.pwdCheck"
            autocomplete="off"
            placeholder="再次输入密码"
            type="password"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="padding-left: 100px" v-if="register">
      提交注册代表您已同意 <el-button type="text" @click="showDeal">用户协议</el-button>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleBack" v-if="(forgetPsd || register) && !type"
        >返回</el-button
      >
      <el-button @click="handleCancle">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
    <el-dialog
      title=""
      :visible.sync="centerDialogVisible"
      width="50%"
      center
      :show-close="false"
      append-to-body
    >
      <div ref="paper"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import LOGIN_SUCCESS from "../index/mixins/login-success.js";
import md5 from "@js/md5.js";
export default {
  mixins: [LOGIN_SUCCESS],
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号码"));
      } else {
        const reg = /^1[3456789]\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的手机号码"));
        } else {
          callback();
        }
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        const reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
        if (!reg.test(value)) {
          callback(new Error("密码为不少于6位的数字字母组合"));
        } else {
          if (this.form.pwdCheck !== "") {
            this.$refs.form.validateField("pwdCheck");
          }
          callback();
        }
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else {
        const reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
        if (!reg.test(value)) {
          callback(new Error("确认密码为不少于6位的数字字母组合"));
        } else if (value !== this.form.pwd) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      }
    };
    return {
      dialogVisible: false,
      activeIndex: "pwd",
      form: {
        usertype: "",
        dwname: "",
        mobile: "",
        captcha: "",
        pwd: "",
        pwdCheck: "",
      },
      countdown: 60,
      messageCodeVis: false,
      showPhone: true,
      forgetPsd: false,
      register: false,
      rules: {
        mobile: [{ required: true, type: "number", validator: validatePhone }],
        captcha: [{ required: true, message: "验证码不能为空", trigger: "blur" }],
        pwd: [{ required: true, validator: validatePass, trigger: "blur" }],
        pwdCheck: [{ required: true, validator: validatePass2, trigger: "blur" }],
      },
      callback: null,
      type: "",
      centerDialogVisible: false,
      //
      reg: "", //注册协议
      title: "登录",
      regType: [],
    };
  },
  computed: {
    ...mapGetters({
      loginStatus: "userinfo/loginStatus",
    }),
  },
  mounted: function () {
    // var usertype = this.getQuery("usertype");

    // if (usertype) {
    //   this.hasUsertype = true;
    //   this.form.usertype = usertype;
    // }

    // this.webName = this.webInfo.webName;
    this.reg = this.webInfo.regPact;
    this.regType = this.webInfo.regType;

    if (this.regType.length === 1) {
      this.form.usertype = this.regType[0];
    }
  },
  methods: {
    handleOpen(callback, type) {
      this.$store.dispatch("userinfo/logout", () => {
        this.title = "登录";
        this.dialogVisible = true;
        if (type == "register") {
          this.title = "注册";
          this.type = type;
          this.$nextTick(() => {
            this.handlerUser(2);
          });
        }
      });
    },
    handleClose() {
      this.type = "";
      this.activeIndex = "pwd";
      this.countdown = 60;
      this.messageCodeVis = false;
      this.$refs.form.resetFields();
      this.showPhone = true;
      this.forgetPsd = false;
      this.register = false;
      this.$emit("cancle");
      this.dialogVisible = false;
      this.handleStatus();
    },
    ...mapMutations({
      userinfoUpdata: "userinfo/userinfoUpdata", //用户信息
    }),

    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.showPhone) {
            //登录
            if (this.activeIndex == "pwd") {
              //手机号、密码登录
              this.$post(
                `${this.$store.state.api.baseUrl}/client/uplogin.json`,
                {
                  username: this.form.mobile,
                  pwd: md5(this.form.pwd),
                },
                (data) => {
                  this.userinfoUpdata(data);
                  showMsg("登录成功", "success");

                  //查登录用户
                  // this.loginSuccess();
                  this.$emit("confirm");
                  this.dialogVisible = false;
                }
              );
            } else if (this.activeIndex == "mobile") {
              //手机号、验证码登录
              this.$post(
                `${this.$store.state.api.baseUrl}/client/mclogin.json`,
                {
                  mobile: this.form.mobile,
                  captcha: this.form.captcha,
                },
                (data) => {
                  this.userinfoUpdata(data);
                  showMsg("登录成功", "success");
                  this.$emit("confirm");
                  this.dialogVisible = false;
                  if (data.otherParams.isnewuser) {
                    this.$alert(
                      "您已成功注册，初始密码为手机号后六位，请及时修改密码",
                      "提示",
                      {
                        confirmButtonText: "确定",
                      }
                    );
                  }
                }
              );
            }
          } else {
            //  /client/sendcaptcha.json
            if (this.register) {
              //注册
              if (this.getQuery("openid")) {
                this.$set(this.form, "openid", this.getQuery("openid"));
              }

              this.$post(
                `${this.$store.state.api.baseUrl}/userreg/userreg.json`,
                this.form,
                function (data) {
                  this.$store.commit("userinfo/userinfoUpdata", data);

                  // window.location.href = "/sys/ordermg/list.html";
                  this.$emit("confirm");
                  this.dialogVisible = false;
                }
              );
            }

            if (this.forgetPsd) {
              //忘记密码
              this.$post(
                `${this.$store.state.api.baseUrl}/userreg/findpwd.json`,
                {
                  mobile: this.form.mobile,
                  captcha: this.form.captcha,
                  newpwd: this.form.pwd,
                },
                (data, res) => {
                  showMsg(res.msg, "success");
                  this.$emit("confirm");
                  this.dialogVisible = false;
                }
              );
            }
          }
        } else {
          return false;
        }
      });
    },
    handleCancle() {
      this.type = "";
      this.activeIndex = "pwd";
      this.countdown = 60;
      this.messageCodeVis = false;
      this.$refs.form.resetFields();
      this.showPhone = true;
      this.forgetPsd = false;
      this.register = false;
      this.$emit("cancle");
      this.dialogVisible = false;
      this.handleStatus();
    },
    handleStatus() {
      if (!this.loginStatus) {
        var path = this.$route.path;
        if (path != "/") {
          this.goto("/");
        }
      }
    },
    showDeal() {
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        this.creatDeal();
      });
    },
    creatDeal() {
      var that = this;

      const Vue = require("vue/dist/vue.esm.js").default;

      that.Temp = Vue.extend({
        template: "<div>" + that.reg + "</div>",
        props: {
          value: {
            type: Object,
            default: function () {
              return {};
            },
          },
          webName: {
            type: String,
            default: "默认",
          },
        },
        data: function () {
          return {
            model: {},
          };
        },
        computed: {},
        methods: {},
        watch: {},
        mounted: function () {},
      });

      //挂载组件
      that.temp = new that.Temp({
        propsData: {
          webName: that.webName,
        },
      }).$mount();

      //清空上一个
      that.$refs.paper.innerHTML = "";
      //添加最新内容
      that.$refs.paper.appendChild(that.temp.$el);
    },
    handleSelect(type) {
      this.activeIndex = type;
      // this.$refs.form.resetFields();
      this.countdown = 60;
      this.messageCodeVis = false;
      this.$refs.form.resetFields();
    },
    /* 倒计时函数 */
    startCountdown() {
      const intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(intervalId);
          this.messageCodeVis = false;
        }
      }, 1000);
    },
    sendCode() {
      if (!this.form.mobile) return showMsg("请先输入手机号！", "warning");
      const reg = /^1[3456789]\d{9}$/;
      if (!reg.test(this.form.mobile))
        return showMsg("请输入正确的手机号码！", "warning");

      if (this.showPhone) {
        if (this.activeIndex == "mobile") {
          //手机号、验证码登录
          //  /client/sendcaptcha.json
          this.$post(
            `${this.$store.state.api.baseUrl}/notify/sendRegisterLoginCode`,
            {
              mobile: this.form.mobile,
              islogin: true,
            },
            (data) => {
              ShowMsg("验证码已发送", "success");
              this.countdown = 60;
              this.messageCodeVis = true;
              this.startCountdown();
            }
          );
        }
      } else {
        this.countdown = 60;
        this.messageCodeVis = true;
        this.startCountdown();
        if (this.register) {
          this.$post(
            //  /userreg/sendcaptcha.json
            `${this.$store.state.api.baseUrl}/notify/sendRegisterCode`,
            {
              mobile: this.form.mobile,
            },
            function (data, res) {
              if (res.msg === "验证码已发送") {
                ShowMsg(res.msg, "success");
              } else {
                ShowMsg(res.msg, "success");
              }
            }
          );
        }

        if (this.forgetPsd) {
          //忘记密码
          this.$post(
            // /client/sendcaptcha.json
            `${this.$store.state.api.baseUrl}/notify/sendForgetPasswordCode`,
            {
              mobile: this.form.mobile,
              islogin: true,
            },
            function (data) {
              ShowMsg("验证码已发送", "success");
              this.settime();
            }
          );
        }
      }
    },
    handlerUser(type) {
      this.$refs.form.resetFields();
      this.countdown = 60;
      this.messageCodeVis = false;
      this.showPhone = false;
      if (type == 1) {
        this.forgetPsd = true;
        this.register = false;
      } else if (type == 2) {
        this.forgetPsd = false;
        this.register = true;
      }
    },
    handleBack() {
      this.countdown = 60;
      this.messageCodeVis = false;
      this.$refs.form.resetFields();
      this.showPhone = true;
      this.forgetPsd = false;
      this.register = false;
    },
  },
};
</script>
<style scoped>
.navList {
  display: flex;
  justify-content: space-evenly;
  font-size: 15px;
  padding: 0 180px;
  margin-bottom: 40px;
}
.moren {
  cursor: pointer;
}
.isActive {
  color: #409eff;
  cursor: pointer;
  border-bottom: 1px solid #409eff;
}
.handlerBtn {
  display: flex;
  padding-left: 100px;
}
</style>
